import {Box, Container, Typography} from "@mui/material";

const TableLoader = ({extra, maxWidth = "xs", subTitle, title}) => {
  return (
    <Container maxWidth={maxWidth}>
      <Box
        sx={{
          textAlign: "center",
          px: 3,
          py: 8,
          display: "flex",
          minHeight: "640px",
          alignItems: "center",
          justifyContent: "space-evenly",
          flexDirection: "column",
        }}
      >
        <Box>
          <Box
            sx={{
              position: "relative",
              marginRight: "40px",
              marginBottom: "30px"
            }}
          >
            <div className="card1"></div>
            <div className="card2"></div>
            <div className="card3"></div>
          </Box>
          <Box>
            <Typography gutterBottom variant="h6">
              {title}
            </Typography>
            {subTitle && <Typography variant="body2">{subTitle}</Typography>}
            {extra && <Box sx={{mt: 4, textAlign: "center"}}>{extra}</Box>}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default TableLoader;
